import React, { Component } from "react";
import PropTypes from "prop-types";
import FilterSelect from "./FilterSelect";


/**
 * @description This is being implemented as a class component because it is a menu 
 *    child and therefore needs to implicitly forward a ref to the menu item children 
 *    further down the tree. Function components cannot be given refs, so if we want 
 *    this abstraction here we need it to be defined as a class.
 */
class ItemFormatFilter extends Component {
	render() {
		const { onChange, value, availableFilters } = this.props;
		const options = availableFilters.map(filter => ({ value: filter.Id, label: filter.Name }));

		return (
			<FilterSelect
				label="Format"
				options={options}
				onChange={onChange}
				value={value ? value : "all"}
			/>
		);
	}
}

export default ItemFormatFilter;

ItemFormatFilter.propTypes = {
	onChange: PropTypes.func,
	value: PropTypes.string
};
